import { render, staticRenderFns } from "./Bgmyproject.vue?vue&type=template&id=2cf73b6f&scoped=true&"
import script from "./Bgmyproject.vue?vue&type=script&lang=js&"
export * from "./Bgmyproject.vue?vue&type=script&lang=js&"
import style0 from "./Bgmyproject.vue?vue&type=style&index=0&id=2cf73b6f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf73b6f",
  null
  
)

export default component.exports